<template>
  <div class="vue-notification">
    <div class="type" :class="notification.type"></div>
    <p class="message">{{ message }}</p>
    <img
      @click="removeNotification(notification)"
      src="@/assets/images/icons/cross_grey.svg"
      class="close"
      alt="close"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex"
export default {
  props: ["notification"],
  computed: {
    type () {
      return this.notification.type
    },
    message () {
      return this.notification.message
    },
  },
  methods: {
    ...mapActions("Util", ["removeNotification"]),
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.vue-notification {
  display: flex;
  align-items: center;
  background: #fff;
  min-width: 29rem;
  height: 5.2rem;
  position: relative;
  border-radius: 6px;
  margin-top: 1rem;
  @include phone-down {
    height: 4rem;
  }
  .type {
    width: 5.2rem;
    height: 5.2rem;
    border-radius: 6px 0 0 6px;
    @include phone-down {
      width: 4rem;
      height: 4rem;
    }
    &.error {
      background-color: #db1d3f;
      background-image: url("../../assets/images/icons/exclamation_with_circle_white.svg");
      background-position: center;
      background-repeat: no-repeat;
    }
    &.success {
      background-color: #f9a821;
      background-image: url("../../assets/images/icons/star_check_white.svg");
      background-position: center;
      background-repeat: no-repeat;
    }
    &.copy {
      background-color: #516be6;
      background-image: url("../../assets/images/icons/copy_white.svg");
      background-position: center;
      background-repeat: no-repeat;
    }
    &.info {
      background-color: #516be6;
      background-image: url("../../assets/images/icons/copy_white.svg");
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .message {
    font-size: 1.5rem;
    color: #000000;
    margin-left: 1.3rem;
  }
  .close {
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: 1.5rem;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Notification.vue